import { Component, Input, OnInit, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import { DocumentService } from '../../services/document.service';
import { ContextDocument } from '../../models/document.model';

@Component({
    selector: 'app-file-download',
    imports: [FontAwesomeModule],
    templateUrl: './file-download.component.html'
})
export class FileDownloadComponent implements OnInit {
  activeModal = inject(NgbActiveModal);

  faCloudArrowDown = faCloudArrowDown;

  @Input() downloadingFile!: ContextDocument;

  errorResponse?: HttpErrorResponse;

  constructor(
    public readonly docSrv: DocumentService,
  ) { }

  ngOnInit(): void {
    this.docSrv.downloadDocument(this.downloadingFile.id).subscribe({
      next: (response) => {
        const fileBlob = response.body;
        if (fileBlob) {
          const link = document.createElement('a');
          const blobUrl = URL.createObjectURL(fileBlob);
          link.href = blobUrl;
          
          // Set the file name
          link.download = this.downloadingFile.name; // Provide the desired file name
          
          // Open the Blob in a new tab
          // window.open(blobUrl, '_blank');
          // Trigger the download
          link.click();
        } else {
          console.error('Errore: il file non è stato trovato.');
        }
      },
      error: (error) => {
        console.error('Errore nel download del documento:', error);
        this.errorResponse = error
      },
      complete: () => this.activeModal.close()
    });
  }
}
